(() => {
  if (customElements.get('le-fragrance-pyramid')) return;
  class FragrancePyramid extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const {signal} = this.controller;
      const dialog = this.querySelector('[data-fragrance-guide]');
      const trigger = this.querySelector('[data-fragrance-guide-open]');
      if (!dialog || !trigger) return;
      trigger.addEventListener('click', () => {
        if (!dialog.open) dialog.showModal();
      }, {signal});
      this.querySelector('[data-fragrance-guide-close]')?.addEventListener('click', () => dialog.close(), {signal});
      dialog.addEventListener('close', () => {
        if (trigger.isConnected) trigger.focus({preventScroll: true});
      }, {signal});
    }
    disconnectedCallback() {
      const dialog = this.querySelector('[data-fragrance-guide]');
      if (dialog?.open) dialog.close();
      this.controller?.abort();
      this.controller = null;
    }
  }
  customElements.define('le-fragrance-pyramid', FragrancePyramid);
})();
